<template>
  <header
    class="tw-pl-5 tw-pr-8 tw-pt-4 tw-pb-3 tw-border-b tw-border-b-gray-200 tw-relative tw-flex tw-justify-between">
    <H2>
      <v-icon
        v-if="titleIcon"
        class="tw-mr-2 -tw-mt-1 tw-text-inherit"
        size="30px">
        {{ titleIcon }}
      </v-icon>
      <slot></slot>
    </H2>
    <slot name="actions">
      <v-btn
        v-if="!hideCloseBtn"
        class="tw-text-ci-gray-500 tw-translate-x-5 -tw-my-1"
        icon
        tabindex="0"
        @click="close">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </slot>
  </header>
</template>

<script>
import H2 from '@/components/Typography/H2.vue'

export default {
  name: 'DialogHeader',
  components: { H2 },
  props: {
    titleIcon: {
      type: String,
      default: null,
    },
    hideCloseBtn: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    close() {
      this.$emit('close')
    },
  },
}
</script>
